import { createContext } from 'react';
export var CurrencyFormatterContext = createContext(null);
var CurrencyFormatterProvider = CurrencyFormatterContext.Provider;
export default CurrencyFormatterProvider;
//# sourceMappingURL=CurrencyFormatterProvider.js.map